//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import AutomaticUploadsTable from "@/pages/AutomaticUploads/components/AutomaticUploadsTable.vue";
import AutomaticUploadsForm from "@/pages/AutomaticUploads/components/AutomaticUploadsForm.vue";
import AutomaticUploadsHistoryTable from "@/pages/AutomaticUploads/components/AutomaticUploadsHistoryTable.vue";
import AutomaticUploadsHistoryForm from "@/pages/AutomaticUploads/components/AutomaticUploadsHistoryForm.vue";
import { Feedback } from "@/utils/notify-toaster.js";

export default {
  name: "AutomaticUploads",
  components: {
    AutomaticUploadsTable,
    AutomaticUploadsForm,
    AutomaticUploadsHistoryTable,
    AutomaticUploadsHistoryForm,
  },
  mounted: function () {
    this.getTableData();
  },
  data: () => ({
    data: [],
    recordsTotal: null,
    filterState: null,
    isLoading: false,
    uploadForm: false,
    scheduling: {},
    schedulingHistory: {},
    historyElement: false,
    newUploadClicked: false,
    existingUploadClicked: false,
    tab: "schedulings",
    pagination: {
      page: 1,
      rowsPerPage: 10,
      recordsTotal: 0,
    },
  }),
  methods: {
    createNewScheduling: function () {
      this.newUploadClicked = true;
      this.existingUploadClicked = false;
      this.historyElement = false;
      this.schedulingHistory = {};
      this.scheduling = { config: {} };
    },
    getTableData: function () {
      this.isLoading = true;
      BackendServices.getSchedulings(this.pagination).then((response) => {
        this.data = Array.isArray(response.data) ? response.data : [];
        this.recordsTotal = response.headers["x-total-count"];
        this.pagination.recordsTotal = this.recordsTotal;
        this.isLoading = false;
      });
    },
    askForData: function (event) {
      this.pagination = event.pagination;
      this.isLoading = true;
      BackendServices.getSchedulings(event.pagination).then((response) => {
        this.data = Array.isArray(response.data) ? response.data : [];
        this.recordsTotal = response.headers["x-total-count"];
        this.isLoading = false;
      });
    },
    renderRightSideHistory(event) {
      this.historyElement = true;
      this.existingUploadClicked = false;
      this.newUploadClicked = false;
      this.schedulingHistory = event;
      this.scheduling = {};
      if (Object.keys(this.schedulingHistory).length === 0) {
        this.historyElement = false;
      }
    },
    renderRightSide(event) {
      if (Object.keys(event).length === 0) {
        this.closeForm()
      } else {
        this.historyElement = false;
        this.existingUploadClicked = true;
        this.newUploadClicked = false;
        this.schedulingHistory = {};
        this.scheduling = event;
      }
    },
    closeForm() {
      this.historyElement = false;
      this.newUploadClicked = false;
      this.existingUploadClicked = false;
      this.scheduling = {};
    },
    saveScheduling() {
      let operation = !this.scheduling.id
        ? BackendServices.createNewScheduling(this.scheduling)
        : BackendServices.updateExistingScheduling(this.scheduling);

      this.isLoading = true;
      operation.then(
        () => {
          this.getTableData();
          Feedback.success("Agendamento guardado com sucesso!");
          this.closeForm();
        },
        () => {
          Feedback.error("Erro a guardar agendamento!");
        }
      );
    },
    async removeScheduling(scheduling) {
      let response = await BackendServices.deleteScheduling(scheduling);
      if (response.status == 204) {
        Feedback.success("Agendamento eliminado com sucesso!");
        this.getTableData();
      }
    },
  },
  watch: {
    tab: {
      handler: function () {
        this.closeForm();
      },
    },
  },
};
